<script>
	// Stores
	import SportEventStore from '@/Stores/Sport/SportEventStore.js';
	// Services
	import { notify } from '@/Services/Notify.js';
	// Components
	import Icon from '@/Components/Icon.svelte';

	export let event;

	function onSuspend() {
		let requestStatus = !event.suspended;
		SportEventStore.updateSuspended(event.id, requestStatus)
			.then(() => {
				notify({
					type: 'success',
					title: event.name,
					message: requestStatus ? 'Event has been suspended' : 'Event has been unsuspended',
					timeout: 3
				});
			})
			.catch((e) => {
				notify({
					type: 'danger',
					title: 'Error!',
					message: (e.error && e.error[0]) || 'Failed to update Event',
					timeout: 5
				});
			});
	}
</script>

<button
	on:click|preventDefault={() => onSuspend()}
	class="flex px-1 items-center justify-center py-1 {event.suspended ? 'btn-warning' : 'btn-muted'}
  btn"
>
	{#if event.suspended}
		<Icon name="lock" classes="w-4 h-4 mr-1" />
	{:else}
		<Icon name="unlock" classes="w-4 h-4 mr-1" />
	{/if}
	<span class="flex-1">Suspend</span>
</button>
